export default __webpack_public_path__ + "reorder-option.png";